import {Action} from "@ngrx/store";
import {IBoosterBenchmark, IBoosterStats} from "../reducers/booster.reducer";
export const SET_IMAGE_AUTO_OPTIMIZATION: string = '[booster] Set image auto optimization';
export const SET_CLEAR_CACHE_STATUS: string = '[booster] Set Clear Cache Status';
export const SET_BOOSTER_STATS: string = '[booster] Set booster stats';
export const LOAD_BOOSTER_BENCHMARK: string = '[booster] Load booster benchmark';
export const LOAD_BOOSTER_BENCHMARK_SUCCESS: string = '[booster] Load booster benchmark success';
export const LOAD_BOOSTER_BENCHMARK_FAIL: string = '[booster] Load booster benchmark fail';


export class SetImageAutoOptimization implements Action {

  readonly type: string = SET_IMAGE_AUTO_OPTIMIZATION;
  constructor(public payload: { websiteId: number, autoOptimize: boolean }) {}

}

export class SetClearCacheStatus implements Action {

  readonly type: string = SET_CLEAR_CACHE_STATUS;
  constructor(public payload: { websiteId: number, cacheEnabled: boolean, cacheDate: number }) {}

}

export class SetBoosterStats implements Action {

  readonly type: string = SET_BOOSTER_STATS;
  constructor(public payload: { websiteId: number, stats: IBoosterStats }) {}

}

export class LoadBoosterBenchmark implements Action {

  readonly type: string = LOAD_BOOSTER_BENCHMARK;
  constructor(public payload: { websiteId: number}) {}

}

export class LoadBoosterBenchmarkSuccess implements Action {

  readonly type: string = LOAD_BOOSTER_BENCHMARK_SUCCESS;
  constructor(public payload: { websiteId: number, benchmark: IBoosterBenchmark }) {}

}

export class LoadBoosterBenchmarkFail implements Action {

  readonly type: string = LOAD_BOOSTER_BENCHMARK_FAIL;
  constructor(public payload: { websiteId: number}) {}

}

export type BoosterAction =
  SetClearCacheStatus | SetBoosterStats | LoadBoosterBenchmark | LoadBoosterBenchmarkSuccess | LoadBoosterBenchmarkFail;
